class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    // Remove the overlay click functionality
    // this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    // Remove the cart icon click functionality
    // cartLink.addEventListener('click', (event) => {
    //   event.preventDefault();
    //   this.open(cartLink);
    // });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      // Removed the event listener for the overlay click here
      // this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);


let cartHoverTimeout;
let drawerLeaveTimeout;

function getCartItemCount() {
  const countBubble = document.querySelector('.cart-count-bubble span');
  if (countBubble) {
    return parseInt(countBubble.innerText.trim()) || 0;
  }
  return 0;
}

if (window.innerWidth > 768) { // Only run on desktop
  const cartIcon = document.querySelector('#cart-icon-bubble');
  const cartDrawer = document.querySelector('cart-drawer.drawer');
  const drawerInner = document.querySelector('.drawer__inner');

  if (cartIcon && cartDrawer && drawerInner) {
    // Open drawer with slight delay but ONLY if cart has items
    cartIcon.addEventListener('mouseenter', () => {
      clearTimeout(drawerLeaveTimeout);
      cartHoverTimeout = setTimeout(() => {
        const itemCount = getCartItemCount();
        if (itemCount > 0) {
          // ✅ Use proper method for drawer behavior
          cartDrawer.classList.add('active');
          // Or preferably → cartDrawer.open(cartIcon);
        }
      }, 50);
    });

    // Mouse leaves icon — cancel pending open
    cartIcon.addEventListener('mouseleave', () => {
      clearTimeout(cartHoverTimeout);
    });

    // If mouse enters drawer, cancel pending close
    drawerInner.addEventListener('mouseenter', () => {
      clearTimeout(drawerLeaveTimeout);
    });

    // When mouse leaves drawer, close after short delay
    drawerInner.addEventListener('mouseleave', () => {
      drawerLeaveTimeout = setTimeout(() => {
        cartDrawer.classList.remove('active');
        // Or preferably → cartDrawer.close();
      }, 200);
    });
  }
}

